import { Banner, Field, Select } from '@cloudflare/kumo';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch';

interface Seq { id: string; name: string; active: boolean }

/** Configuração do bloco "Sequência" no Flow Builder */
export function SequenceEnrollConfig({ config, setConfig }: { config: any; setConfig: (c: any) => void }) {
  const fetchApi = useAuthenticatedFetch();
  const [seqs, setSeqs] = useState<Seq[] | null>(null);
  useEffect(() => {
    fetchApi('/api/sequences').then((r) => (r.ok ? r.json() : { sequences: [] })).then((d) => setSeqs(d.sequences || [])).catch(() => setSeqs([]));
  }, [fetchApi]);

  const options = useMemo(
    () => (seqs || []).map((s) => ({ value: s.id, label: `${s.name}${s.active ? '' : ' (pausada)'}` })),
    [seqs]
  );
  const selectedOption = options.find((o) => o.value === config.sequenceId) ?? null;

  if (seqs && !seqs.length) {
    return <Banner variant="default" description={<>Nenhuma sequência criada. Crie uma em <Link to="/sequencias">Campanhas › Sequências</Link>.</>} />;
  }
  const chosen = seqs?.find((s) => s.id === config.sequenceId);
  return (
    <div className="space-y-3">
      <div className="text-kumo-subtle" style={{ color: 'var(--text-muted)' }}>O contato que passar por este bloco entra na sequência escolhida (quem já está nela continua de onde parou).</div>
      <Field label="Sequência">
        <Select value={(selectedOption)?.value ?? null} items={options} onValueChange={(value: string | null) => {
            const id = value;
            if (!id) return;
            setConfig({ ...config, sequenceId: id, sequenceName: seqs?.find((s) => s.id === id)?.name || '' });
          }} placeholder="Escolha a sequência" />
      </Field>
      {chosen && !chosen.active && <Banner variant="alert" description={<>Esta sequência está pausada: o contato é inscrito, mas só recebe quando ela for ativada.</>} />}
    </div>
  );
}
